var existMenu = function (parentNode) {
    if (parentNode === void 0) { parentNode = document; }
    return !!((parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('.layout5-menu-item')) || (parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('.layout5-sub-menu-item')));
};
var isMenu = function (node) { var _a, _b; return ((_a = node === null || node === void 0 ? void 0 : node.classList) === null || _a === void 0 ? void 0 : _a.contains('layout5-menu-item')) || ((_b = node === null || node === void 0 ? void 0 : node.classList) === null || _b === void 0 ? void 0 : _b.contains('layout5-sub-menu-item')) || existMenu(node); };
var existBillCard = function (parentNode) {
    if (parentNode === void 0) { parentNode = document; }
    return !!((parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('#card-my-bills div[data-testid="home-card-empty"]')) || (parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('#card-my-bills .bill-info-title-wrapper')));
};
var isBillCard = function (node) { var _a, _b, _c; return ['home-card-empty'].includes((_b = (_a = node) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.testid) || ((_c = node === null || node === void 0 ? void 0 : node.classList) === null || _c === void 0 ? void 0 : _c.contains('bill-info-title-wrapper')) || existBillCard(); };
var existDxTableCell = function (parentNode) {
    if (parentNode === void 0) { parentNode = document; }
    return !!((parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('td[role="gridcell"]')) || (parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('.dx-datagrid-nodata')));
};
var isDxTableCell = function (node) {
    var _a;
    return ((node === null || node === void 0 ? void 0 : node.tagName) === 'TD' && (node === null || node === void 0 ? void 0 : node.role) === 'gridcell') || ((_a = node === null || node === void 0 ? void 0 : node.classList) === null || _a === void 0 ? void 0 : _a.contains('.dx-datagrid-nodata')) ||
        existDxTableCell();
};
var existMyBills = function (parentNode) {
    if (parentNode === void 0) { parentNode = document; }
    return !!((parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('#ListPartDataContainer')) || existDxTableCell(parentNode));
};
var isMyBills = function (node) {
    return node.id === 'ListPartDataContainer' ||
        isDxTableCell(node) ||
        existMyBills();
};
var existBillTitle = function (parentNode) {
    if (parentNode === void 0) { parentNode = document; }
    return !!(parentNode === null || parentNode === void 0 ? void 0 : parentNode.querySelector('[data-testid="bill-title"]'));
};
var isBillTitle = function (node) {
    var _a, _b;
    return ((_b = (_a = node) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.testid) === 'bill-title' || existBillTitle();
};
export var FMP_MONITOR_CONFIG_MAP = {
    home: {
        isFMPNode: function (node) {
            return (isMenu(node) && existBillCard()) || (isBillCard(node) && existMenu());
        },
        params: function () { return ({
            title: '首页FMP'
        }); },
        rule: function (hash) { return ['/new-homepage'].includes(hash); }
    },
    bills: {
        isFMPNode: function (node) {
            return (isMenu(node) && existMyBills()) || (isMyBills(node) && existMenu());
        },
        params: function () { return ({
            title: '我的单据FMP'
        }); },
        rule: function (hash) { return ['/bills'].includes(hash); }
    },
    todo: {
        isFMPNode: function (node) {
            return (isMenu(node) && existDxTableCell()) || (isDxTableCell(node) && existMenu());
        },
        params: function () { return ({
            title: '待办FMP'
        }); },
        rule: function (hash) { return ['/audit/approve', '/audit/payment', '/todo/print', '/audit/carbonCopy', '/expense-manage'].includes(hash); }
    },
    billDetail: {
        isFMPNode: function (node) {
            return !existMenu() && isBillTitle(node);
        },
        params: function () { return ({
            title: '单据详情FMP',
        }); },
        rule: function (hash) { return (hash === null || hash === void 0 ? void 0 : hash.startsWith('/backlogDetail/')) || (hash === null || hash === void 0 ? void 0 : hash.startsWith('/billEntryDetail')); }
    }
};
